export default __webpack_public_path__ + "static/media/icon-locationn.0bfe1cd3.svg";